module.exports = __webpack_public_path__ + "static/media/baby.f6aed500.svg";